// extracted by mini-css-extract-plugin
export var button = "_6i-4";
export var hasDarkBackground = "_6i-7";
export var hasLightBackground = "_6i-6";
export var iconWrapper = "_6i-0";
export var large = "_6i-2";
export var medium = "_6i-1";
export var small = "_6i-5";
export var xsmall = "_6i-3";